import React, { useCallback, useEffect } from "react";
import { Link } from "react-router";
import { DebounceInput } from "react-debounce-input";

import {
  emptyString,
  loginConstants,
  performanceConstants,
} from "../../../constants";
import { setItemToStorage } from "../../../../../system";
import {
  useSpinner,
  Spinner,
  DataTable,
  StatusCard,
  ExportButton,
  ChangeComponent,
  escapeSearchQuery,
  calculateChangeColumnValue,
  guestSentimentPaginatedPostRequestBody,
} from "../../../../../shared";
import { getStarRatingTableColumns } from "../utility";

//Extract required properties using destructuring
const { ALL_BRAND_RESPONSE_DATA } = performanceConstants;

const StarRatingTab = (props) => {
  //You can Extract any data OR Function that this component receive as PROPS
  const {
    frRoute,
    maxStar,
    minStar,
    dayCounts,
    exportFunc,
    createDateTo,
    createDateFrom,
    selectedOption,
    totalResponses,
    totalRestaurants,
    sortingStarRating,
    userResponsesData,
    setSortingStarRating,
    getAllBrandsResponses,
    searchStringStarRating,
    setSearchStringStarRating,
    userResponseDataPagination,
  } = props;

  // Show loading while a request is running.
  const spinner = useSpinner();

  const cellNameRenderer = useCallback(
    ({ row }) => {
      const { id, name } = row.original;
      return (
        <Link
          className="table-links"
          to={`/stores/brand-profile/${id}`}
          onClick={() => {
            setItemToStorage(loginConstants.BRAND_NAME, name);
            setItemToStorage(loginConstants.BRAND_ID, id);
          }}
        >
          {name}
        </Link>
      );
    },
    // eslint-disable-next-line
    []
  );

  const headerSurveyCompletionDateRenderer = useCallback(
    () => {
      return (
        <span className="text-secondary">
          PREVIOUS {dayCounts === 1 ? `${dayCounts} DAY` : `${dayCounts} DAYS`}
        </span>
      );
    },
    // eslint-disable-next-line
    [dayCounts]
  );

  const cellChangeRenderer = useCallback(
    ({ row }) => {
      const { change, isValueGreaterThanZero } = row.original;
      return (
        <ChangeComponent
          result={change}
          isValueGreaterThanZero={isValueGreaterThanZero}
        />
      );
    },
    // eslint-disable-next-line
    []
  );

  //Set pagination details with request body
  const getPaginatedPostRequestBody = (pageNumber, sortBy, size) => {
    const averageSentiments = {
      min: minStar,
      max: maxStar,
    };
    const requestBody = guestSentimentPaginatedPostRequestBody({
      pagination: userResponseDataPagination,
      pageNumber: pageNumber,
      sortBy: sortBy || sortingStarRating,
      filterQuery: emptyString,
      averageSentiments: averageSentiments,
      isFrRoute: frRoute,
      size: size,
    });
    if (sortBy) {
      setSortingStarRating(sortBy);
    }

    return {
      ...requestBody,
      search: escapeSearchQuery(searchStringStarRating),
    };
  };

  const getData = (pageNumber, sortBy, size) => {
    const requestBody = getPaginatedPostRequestBody(pageNumber, sortBy, size);
    getAllBrandsResponses(createDateFrom, createDateTo, requestBody);
  };

  useEffect(() => {
    if (userResponsesData && userResponsesData.length > 0) {
      calculateChangeColumnValue(userResponsesData);
    }
    // eslint-disable-next-line
  }, [userResponsesData]);

  useEffect(() => {
    getData(0, null, userResponseDataPagination.size);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchStringStarRating, createDateTo, createDateFrom, selectedOption]);

  return (
    <>
      {spinner(ALL_BRAND_RESPONSE_DATA) && <Spinner />}
      <div className="container-fluid pt-2">
        <div className=" d-md-flex mb-3 justify-content-between mt-2">
          <StatusCard
            title="Total Brands"
            data={totalRestaurants}
            classNames="me-3 mb-3 mb-md-0"
            bodyClassNames="p-3"
          />
          <StatusCard
            title={
              !selectedOption?.starRating?.length ||
              selectedOption.starRating.find((item) => item.label === "All")
                ? "Total Responses"
                : `Total ${selectedOption.starRating.map(
                    (item) => item.value
                  )} Star Responses`
            }
            data={totalResponses}
            classNames=""
            bodyClassNames="p-3"
          />
        </div>
        <ExportButton
          exportFunc={exportFunc}
          isDisabled={!userResponseDataPagination.totalElements}
        />
        <div className="notification-form card shadow mb-5">
          <div className="card-body px-0">
            <div className="row">
              <div className="col-6 py-1">
                <h5 className=" responses ps-4 m-0">Total Brands</h5>
              </div>
              <div className="col-6 py-1">
                <div className="search-container ms-auto me-4">
                  <DebounceInput
                    type="text"
                    value={searchStringStarRating}
                    placeholder="Search"
                    debounceTimeout={1000}
                    className=" search-restaurants"
                    id="search-store-locations"
                    onChange={(e) => setSearchStringStarRating(e.target.value)}
                  />
                  <i aria-hidden="true" className="fa fa-search search-icon" />
                </div>
              </div>
            </div>
            <div className="mt-3">
              <DataTable
                columns={getStarRatingTableColumns(
                  cellNameRenderer,
                  cellChangeRenderer,
                  headerSurveyCompletionDateRenderer
                )}
                sortedBy={sortingStarRating}
                data={userResponsesData}
                onPageChange={(pageNum) =>
                  getData(pageNum, null, userResponseDataPagination.size)
                }
                onColumnSort={(sortBy) =>
                  getData(
                    userResponseDataPagination.number,
                    sortBy,
                    userResponseDataPagination.size
                  )
                }
                onSizeChange={(size, pageNum) => {
                  getData(pageNum, null, size);
                }}
                pageNumber={userResponseDataPagination.number + 1}
                pageSize={userResponseDataPagination.size}
                numberOfRowsPerPage={userResponseDataPagination.size}
                totalRows={userResponseDataPagination.totalElements}
                isPaginationDropDownEnable={true}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StarRatingTab;
